export const breadcrumbItems = [
    { label: "Give Away Products", link: "/auth/give-away-products" },
];
